import type { ComponentProps, ReactNode } from 'react';

import { Box, Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { MapLocationSearch } from 'components/marketplace/map/LocationSearch';
import type { LocationSearchProps } from 'components/marketplace/map/LocationSearch';
import { QuickBedroomsBathroomsFilter } from 'components/marketplace/map/QuickBedroomsBathroomsFilter';
import { QuickPriceFilter } from 'components/marketplace/map/QuickPriceFilter';

type QuickFiltersProps = Pick<
  LocationSearchProps,
  'isFocused' | 'selection' | 'onSelectionChange'
> & {
  bathrooms: string;
  bedrooms: string;
  maxBedrooms: string;
  minPrice?: number | null;
  maxPrice?: number | null;
  onFilterChange: ComponentProps<typeof QuickBedroomsBathroomsFilter>['onChange'];
  onPriceChange: (minPrice: number | null, maxPrice: number | null) => void;
  onFiltersButtonClick: () => void;
  /** Primary inventory-set filter (For sale / Available soon). */
  inventoryControl?: ReactNode;
};

export const QuickFilters = ({
  bathrooms,
  bedrooms,
  maxBedrooms,
  minPrice,
  maxPrice,
  onFilterChange,
  onPriceChange,
  onFiltersButtonClick,
  isFocused,
  selection,
  onSelectionChange,
  inventoryControl,
}: QuickFiltersProps) => (
  <Col className="sticky top-0 z-10 w-full shrink-0 border-b border-od-border-tertiary bg-od-bg-primary px-5 py-3 lg:px-6">
    <Row className="w-full flex-wrap items-center gap-2">
      <Box className="min-w-40 flex-1">
        <MapLocationSearch
          selection={selection}
          onSelectionChange={onSelectionChange}
          isFocused={isFocused}
          showLabel={false}
          size="xs"
        />
      </Box>
      {inventoryControl}
      <QuickPriceFilter minPrice={minPrice} maxPrice={maxPrice} onChange={onPriceChange} />
      <QuickBedroomsBathroomsFilter
        bedrooms={bedrooms}
        maxBedrooms={maxBedrooms}
        bathrooms={bathrooms}
        onChange={onFilterChange}
      />
      <Button
        analyticsName="filter-property-search"
        aria-label="All Filters"
        onClick={onFiltersButtonClick}
        variant="secondary"
        size="sm"
        className="h-10 px-3"
      >
        Filters
      </Button>
    </Row>
  </Col>
);
